import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import dayjs from 'dayjs';
import { createBrowserRouter, RouterProvider } from 'react-router';
import Layout from './Pages/Layout';
import Dashboard from './Pages/Dashboard';
import Equipe from './Pages/Equipe';
import Planning from './Pages/Planning';
import Formations from './Pages/Formations';
import Performances from './Pages/Performances';
import { ThemeProvider } from '@mui/material/styles';
import { Theme } from './themes/Theme';
import CssBaseline from '@mui/material/CssBaseline';
import Users from './Pages/Users';
import RegularWeeklyShifts from './Pages/RegularWeeklyShifts';
import isoWeek from 'dayjs/plugin/isoWeek';
import Parametres from './Pages/Parametres';

var weekOfYear = require("dayjs/plugin/weekOfYear");

dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);

function ErrorFallback() {
  const basePath = (process.env.PUBLIC_URL || '/').replace(/\/+$/, '') || '/';

  return (
    <div style={{ padding: 32, textAlign: 'center' }}>
      <h1>Une erreur est survenue</h1>
      <p>La page demandée n'existe pas ou une erreur s'est produite.</p>
      <a href={`${basePath}/`}>Retour à l'accueil</a>
    </div>
  );
}


const normalizedBaseName = (process.env.PUBLIC_URL || '/')
  .replace(/\/+$/, '')
  .replace(/^$/, '/');

const router = createBrowserRouter([
  {
    
    Component: App,
    errorElement: <ErrorFallback />, // Ajout du composant d'erreur global
    children: [
      {
        path: '/',
        Component: Layout,
        errorElement: <ErrorFallback />, // Ajout du composant d'erreur pour les routes enfants
        children: [
          {
            path: '',
            Component: Dashboard,
          },
          {
            path: 'equipe',
            Component: Equipe,
          },
          {
            path: 'planning',
            Component: Planning,
          },
          {
            path: 'formations',
            Component: Formations,
          },
          {
            path: 'performances',
            Component: Performances,
          },
          {
            path: 'besoins-reguliers',
            Component: RegularWeeklyShifts,
          },
          {
            path: 'utilisateurs',
            Component: Users,
          },
          {
            path: 'parametres',
            Component: Parametres,
          }
        ],
      },
    ],
  },
], {
  basename: normalizedBaseName,
});



const theme = Theme;
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>
);

